export default class Subnavs {
    
    constructor() {
        this.subnavs = $(document).find('.subnav');
        this.currentURL = window.location.pathname.split('/');
        this.featuredNavItems = $(document).find('a[data-page-featured]');
        this.setActiveLink();
        this.removeOldFeaturedLinks();
    }

    /**
     * Make the active subnav item red - active state
     * Make the featured subnav item featured
     */
    setActiveLink() {
        let url = '/' + this.currentURL[1] + '/' + this.currentURL[2];
        this.subnavs.find('a').removeClass('active');
        this.subnavs.find('a[href="'+url+'"]').addClass('active');
        this.featuredNavItems.addClass('featured');
    }


    /**
     * Remove the featured red dot next to featured dom elements
     * after they have passed their start date by 2 week. 
     * The start date is set by the DOM data attribute data-page-featured="02/22/2018"
     * with the value being set to todays date in the above format.
     */
    removeOldFeaturedLinks() { 

        // Add days to date function 
        Date.prototype.addDays = function(days) {
            this.setDate(this.getDate() + parseInt(days));
            return this;
        };

        let itemDate = null;
        let today = new Date();

        this.featuredNavItems.each((index, item) => {
            let $item = $(item); 
            // - data-page-featured = when page was changed
            // - add 2 weeks to the current changed date
            itemDate = new Date($item.attr('data-page-featured')).addDays(14); 
            // If today is 2 weeks after the page's updated date, remove the feature class.
            if (today > itemDate) { $item.removeClass('featured'); }
        }); 

    }
}


// WEBPACK FOOTER //
// ./public/js/Subnavs.js